import { LitElement, html, nothing } from 'lit';

import { SimpleRouterMixin } from './mixins/simple-router-mixin';

customElements.define(
  "ks-booking-navigation",
  class extends SimpleRouterMixin(LitElement) {
    static get properties() {
      return {
        tokenValue: {},
      };
    }

    createRenderRoot() {
      return this;
    }

    render() {
      return html`
        <nav class="flex">
          ${this.tokenValue
            ? html`
                <a
                  class="link"
                  href="${this.featureBasePath}requests/list/"
                  aria-current="${ this._currentUrl?.toString()?.includes?.('requests/list/') ? "page" : "false" }"
                >Dashboard</a>
                <a
                  class="link"
                  href="${this.featureBasePath}calendar/"
                  aria-current="${ this._currentUrl?.toString()?.includes?.('calendar/') ? "page" : "false" }"
                >Calendar</a>
              `
            : nothing
          }
          <a
            href="https://www.kasorb.com/courses"
            target="_blank"
            class="link link-bk link-bk-md"
          >Courses</a>
          <a
            href="https://www.kasorb.com/"
            target="_blank"
            class="link link-bk link-bk-md"
          >Website</a>
          ${this.tokenValue
            ? html`
                ${this._routeTemplate}
                <a
                  href="#"
                  class="link"
                  @click=${() => {
                    this.tokenValue = undefined;
                    this.dispatchEvent(new Event('logout'));
                    this.navigation.navigate(`${this.featureBasePath}authentication/`);
                  }}
                >Logout</a>`
            : nothing
          }
        </nav>
      `;
    }

    /**
     * Returns an array of routes to be used.
     *
     * @returns {Array<Object>}
     */
    _setupRoutes() {
      return [
        {
          pattern: new URLPattern({
            pathname: `${this.featureBasePath}requests/list/*`,
          }),
          handler: async() => {
            return html`
              <a
                style="margin-inline-start: auto;"
                class="btn primary"
                href="${this.featureBasePath}requests/create/"
              >Book</a>
            `;
          },
        },
        {
          id: 'shell-empty',
          pattern: new URLPattern({
            pathname: `${this.featureBasePath}*`,
          }),
          handler: async () => {
            return html`
              <div style="margin-inline-start: auto;"></div>
            `;
          },
        }
      ];
    }
});
